<template>
	<v-card>
		<v-card-title class="text-primary">
			<translate>Your payment is successful!</translate>
		</v-card-title>
		<v-card-text>
			<!-- eslint-disable-next-line vue/no-v-html value not injected, so it's safe-->
			<p v-html="$gettext('Look in your <a href=\'/login\'>Tulip Assist account</a> to see the current status of your invoices and payments. Go to \'Dashboard\' and click on \'My invoices\'')" />
		</v-card-text>
	</v-card>
</template>

<script>

export default {
	name: 'AdyenSuccessCard'
};
</script>
